import React, { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import GetVendorDetailsById from '../../../APIs/AddVendor/GetVendorDetailsById'
import PageHeading from '../../../components/PageHeading'

export default function ViewProfileIndividualVendorCompany() {
    let id = useParams()
    let navigate = useNavigate()
    let [companydata, setCompanyData] = useState([])
    let getData = async (id) => {

        let resp = await GetVendorDetailsById(id)
        if (resp.status === 1) {
            setCompanyData(resp.responseValue[0])
            // console.log("data", resp.responseValue[0])
        }
    }
    useEffect(() => {
        getData(id.id)
    }, [])

    let handleEdit = () => {
        navigate("/addcompanyvendor/" + id.id)
    }
    return (
        <>
            {
                companydata.length !== 0 ?
                    <>

                        <div className='container-fluid landformconatiner p-4'>
                            <div className='d-flex flex-row justify-content-between'>
                                <PageHeading pagename="Vendor Details" />
                                <button className='editProject' onClick={handleEdit}><i class="fa-regular fa-pen-to-square fa-lg"></i>&nbsp; Edit Details</button>
                            </div>
                            <div className='row'>
                                <span className='text-secondary'>#2156460511</span>
                            </div>
                            <div className='d-flex flex-row gap-2 mt-3'>
                                <div style={{ width: "40px", height: "40px", backgroundColor: "#03D4C6", borderRadius: "20px" }}></div>
                                <span className='d-flex flex-column gap-1 pt-1 ps-2'>
                                    <label className='heading-project fw-semibold'>{companydata.name}</label>
                                    <label className='heading-project' style={{ color: "#737791" }}>{companydata.address}</label>
                                </span>
                            </div>

                        </div>

                        <div className='container-fluid landformconatiner mt-2 p-4'>
                            <div className='d-flex flex-row justify-content-between'>
                                <PageHeading pagename="Personal Details" />
                            </div>
                            <div className='wrapform pt-3'>
                                <div className='d-flex flex-column gap-1'>
                                    <label className='form-label'>Your Name</label>
                                    <span className='text-secondary'>{companydata.name}</span>
                                </div>
                                <div className='d-flex flex-column gap-1'>
                                    <label className='form-label'>Email Address</label>
                                    <span className='text-secondary'>{companydata.emailId}</span>
                                </div>
                                {/* <div className='d-flex flex-column gap-1'>
                            <label className='form-label'>Invested in Any Property</label>
                            <span className='text-secondary'>#2156460511</span>
                        </div> */}

                                <div className='d-flex flex-column gap-1'>
                                    <label className='form-label'>Mobile No.</label>
                                    <span className='text-secondary'>{companydata.mobileNo}</span>
                                </div>
                                <div className='d-flex flex-column gap-1'>
                                    <label className='form-label'>State</label>
                                    <span className='text-secondary'>{companydata.stateName}</span>
                                </div>
                                <div className='d-flex flex-column gap-1'>
                                    <label className='form-label'>City</label>
                                    <span className='text-secondary'>{companydata.cityName}</span>
                                </div>

                                <div className='d-flex flex-column gap-1'>
                                    <label className='form-label'>Pin Code</label>
                                    <span className='text-secondary'>{companydata.pincode}</span>
                                </div>
                                <div className='d-flex flex-column gap-1'>
                                    <label className='form-label'>Address</label>
                                    <span className='text-secondary'>{companydata.address}</span>
                                </div>
                                {/* <div className='d-flex flex-column gap-1'>
                            <label className='form-label'>Unique Id if you have</label>
                            <span className='text-secondary'>#2156460511</span>
                        </div> */}
                            </div>

                        </div>


                        <div className='container-fluid landformconatiner mt-2 p-4'>
                            <div className='d-flex flex-row justify-content-between'>
                                <PageHeading pagename="Bank Details" />
                            </div>
                            <div className='wrapform pt-3'>
                                <div className='d-flex flex-column gap-1'>
                                    <label className='form-label'>Bank Name</label>
                                    <span className='text-secondary'>{companydata.bankDetails.bankName}</span>
                                </div>
                                <div className='d-flex flex-column gap-1'>
                                    <label className='form-label'>Account Holder's Name</label>
                                    <span className='text-secondary'>{companydata.bankDetails.accountHolderName}</span>
                                </div>
                                <div className='d-flex flex-column gap-1'>
                                    <label className='form-label'>Branch Code</label>
                                    <span className='text-secondary'>{companydata.bankDetails.branchCode}</span>
                                </div>

                                <div className='d-flex flex-column gap-1'>
                                    <label className='form-label'>Bank Account No</label>
                                    <span className='text-secondary'>{companydata.bankDetails.accountNo}</span>
                                </div>
                                <div className='d-flex flex-column gap-1'>
                                    <label className='form-label'>IFSC Code</label>
                                    <span className='text-secondary'>{companydata.bankDetails.ifscCode}</span>
                                </div>

                            </div>

                        </div>


                        <div className='container-fluid landformconatiner mt-2 p-4'>
                            <div className='d-flex flex-row justify-content-between'>
                                <PageHeading pagename="Documents" />
                            </div>
                            <div className='wrapform pt-3'>
                                <div className='d-flex flex-column gap-1'>
                                    <label className='form-label'>Document Type</label>
                                    {/* <span className='text-secondary'>#2156460511</span> */}
                                    <div className='d-flex flex-row gap-3' style={{ overflowX: "auto", width: "90%" }}>
                                        {
                                            companydata.documents.length &&
                                            companydata.documents.map((val, ind) => {
                                                return (<>
                                                    <img src={val.image} alt='document' />
                                                </>)
                                            })

                                        }
                                    </div>
                                </div>


                            </div>

                        </div>
                    </>

                    : ""
            }


        </>)
}
